import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function createFusionUser(
  role,
  base,
  department,
  rank,
  name,
  email,
  employeeId,
  phoneNumber,
  gender,
  birthday,
  address,
  emergencyContact,
  isAdmin,
  isMaintenance,
  maintenanceOperatorLevel,
  serviceManager,
  deploymentManager = 0,
  url = window.location.origin,
  avatar = null,
  widget_list = null,
  user_save = null,
  company_save = null,
) {
  try {
    return await apiClient.post('/users', {
      role,
      base,
      department,
      rank,
      name,
      email,
      employeeId,
      phoneNumber,
      gender,
      birthday,
      address,
      emergencyContact,
      isAdmin,
      isMaintenance,
      maintenanceOperatorLevel,
      serviceManager,
      deploymentManager,
      avatar,
      widget_list,
      user_save,
      company_save,
      url,
    });
  } catch (error) {
    console.error('fusionCreate failed.', error);
    //on error, return an object with status and message to handle it in the UI
    return {
      isError: true,
      status: error.response?.status,
      message: error.response?.data?.message || 'Unknown error',
    };
  }
}

export async function updateUserProfile(phoneNumber, gender, birthday, address, emergencyContact) {
  try {
    return await apiClient.put('/users/profile', {
      phoneNumber,
      gender,
      birthday,
      address,
      emergencyContact,
    });
  } catch (error) {
    console.error('updateFusionUserProfile failed.', error);
  }
}

export async function updateUserProfileOptions(options) {
  try {
    return await apiClient.put('/users/profile', { options });
  } catch (error) {
    console.error('updateUserProfileOptions failed.', error);
  }
}

export async function updateUserProfileByAdmin(
  userId,
  role,
  base,
  department,
  rank,
  name,
  employeeId,
  phoneNumber,
  gender,
  birthday,
  address,
  emergencyContact,
  isAdmin,
  isMaintenance,
  maintenanceOperatorLevel,
  serviceManager,
  deploymentManager = 0,
) {
  try {
    return await apiClient.put(`/users/${encodeURIComponent(userId)}`, {
      role,
      base,
      department,
      rank,
      name,
      employeeId,
      phoneNumber,
      gender,
      birthday,
      address,
      emergencyContact,
      isAdmin,
      isMaintenance,
      maintenanceOperatorLevel,
      serviceManager,
      deploymentManager,
    });
  } catch (error) {
    console.error('updateUserProfileByAdmin failed.', error);
  }
}

export async function getUserProfileInfo(userId = null) {
  try {
    if (userId == null) {
      return await apiClient.get('/users/profile');
    }
    return await apiClient.get(`/users/${encodeURIComponent(userId)}/profile`);
  } catch (error) {
    console.error('getFusionUserProfile failed.', error);
  }
}

export async function checkFusionUserEmail(email) {
  try {
    return await apiClient.get(`/users/email/${encodeURIComponent(email)}/exists`);
  } catch (error) {
    console.error('checkFusionUserEmail failed.', error);
  }
}

export async function deleteUser(deleteId) {
  try {
    loginfo();
    return await apiClient.delete(`/users/${encodeURIComponent(deleteId)}`);
  } catch (error) {
    console.error('deleteUser failed.', error);
  }
}

export async function submitFusionInquiry(name, email, phone, notes) {
  try {
    loginfo();
    return await apiClient.post('/license/inquiries', {
      name,
      email,
      phone,
      notes,
    });
  } catch (error) {
    console.error('fusionInquiries failed.', error);
  }
}
